import { createSelector } from 'reselect'
import { getOrgName } from 'store/AppState/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import { getSortedConfigurationModels } from 'utils/revenueCenters'
import { filterByVenueAndOrgName } from './utils'

export const getAllConfigurationModels = createSelector(
  getCurrentVenueUuid,
  getOrgName,
  (state) => state?.configurationModels?.byId ?? {},
  (currentVenueUuid, currentOrgName, configurationModels) => {
    const sortedConfigurationModels = getSortedConfigurationModels(
      Object.values(configurationModels)
    )

    return sortedConfigurationModels?.filter(
      ({ venueUuid, organizationName }) => {
        return filterByVenueAndOrgName(
          venueUuid,
          organizationName,
          currentVenueUuid,
          currentOrgName
        )
      }
    )
  }
)

export const getIsLoadingConfigurationModels = (state) =>
  state?.configurationModels?.isLoading ?? false
